import React, { useState } from "react";
import {
  RightSidebar,
  RightSidebarHeader,
  RightSidebarSaveFooter
} from "../RightSidebar";
import FileUploader from "../FileUploader/FileUploader";
import useProductImport from "./useProductImport";
import styles from "./ProductImportSidebar.module.scss";
import { useMutation } from "@apollo/react-hooks";
import { ImportProducts } from "./mutations";
import { useMixpanel } from "react-mixpanel-browser";
import { Callout, Button, Intent } from "@blueprintjs/core";

function ProductImportSidebar({ isImportSidebarOpen, onImportSidebarClose }) {
  const [importedProducts, setImportedProducts] = useState([]);
  const { uploading, onFileChange, onSave, error } = useProductImport({
    setImportedProducts,
    isImportSidebarOpen,
    onImportSidebarClose
  });

  return (
    <RightSidebar sidebarIsOpen={isImportSidebarOpen}>
      <RightSidebarHeader
        title="Upload a CSV"
        isDismissDisabled={uploading}
        onDismiss={onImportSidebarClose}
      />

      <div className={styles.contentContainer}>
        <div>Upload a CSV</div>

        <Callout style={{ marginTop: "15px" }}>
          Download the template product_import.csv. Add your products using this
          format, then add your file here to begin the import.
          <Button
            onClick={() =>
              window.open(
                "https://s3.amazonaws.com/zipline.assets/video_squirrel_import_example.csv",
                "_blank"
              )
            }
          >
            Download Template
          </Button>
        </Callout>

        <p className={styles.detail}>
          Once your CSV file is uploaded, you’ll be able to review it under your
          products section.
        </p>
        {error && (
          <Callout intent={Intent.DANGER} style={{ marginBottom: "1em" }}>
            {error}
          </Callout>
        )}
        {!error && importedProducts.length > 0 && (
          <Callout intent={Intent.SUCCESS} style={{ marginBottom: "1em" }}>
            CSV parsed & uploaded succesfully. Please click upload to review it.
          </Callout>
        )}
        <FileUploader
          title="Upload a CSV"
          uploading={uploading}
          onFileChange={onFileChange}
        />
      </div>

      <RightSidebarSaveFooter
        saveLabel="Upload"
        onCancel={onImportSidebarClose}
        pageIsLoading={uploading}
        disableSave={uploading || !importedProducts.length}
        onSave={async () => {
          await onSave(importedProducts);
        }}
      />
    </RightSidebar>
  );
}

export default ProductImportSidebar;
